import { Spin } from "antd";
import * as L from "leaflet";
import PropTypes from "prop-types";
import React from "react";
import { Table } from "react-bootstrap";
import ReactDOMServer from "react-dom/server";
import { GiPositionMarker } from "react-icons/gi";
import { Marker, Popup } from "react-leaflet";
import { Link } from "react-router-dom";

const MapMarker = ({ site, markerLoading, handleMarkerClick, markerData }) => {
  const customIcon = new L.divIcon({
    className: "custom-marker",
    html: ReactDOMServer.renderToString(
      <GiPositionMarker style={{ color: getMarkerColor(site?.alarmStatus), fontSize: "45px" }} />,
    ),
  });

  const latitude = site?.latitude;
  const longitude = site?.longitude;
  if (!latitude || !longitude) return null;
  return (
    <Marker
      position={[latitude, longitude]}
      eventHandlers={{ click: () => handleMarkerClick(site._id) }}
      pathOptions={{ color: "red" }}
      icon={customIcon}
    >
      <Popup>
        <Spin spinning={markerLoading}>
          <h6 className="fw-bold"> {site?.name} </h6>
          <Table className="table-borderless fw-bold">
            <tbody>
              <tr className="table-primary">
                <td className="py-1">Total Devices</td>
                <td className="py-1"> : </td>
                <td className="py-1">{markerData?.totalDevices || 0}</td>
              </tr>
              <tr className="table-success">
                <td className="py-1">Online Devices</td>
                <td className="py-1"> : </td>
                <td className="py-1 text-success">{markerData?.activeSensors}</td>
              </tr>
              <tr className="table-danger">
                <td className="py-1">Offline Devices</td>
                <td className="py-1"> : </td>
                <td className="py-1 text-danger">{markerData?.inactiveSensors}</td>
              </tr>
            </tbody>
          </Table>
          <div>
            <p className="font-weight-bold mb-0">Address:</p>
            <p className="mt-0">{markerData?.siteAddress || "--"}</p>
          </div>
          <div className="d-flex justify-content-end">
            <Link role="button" className="btn btn-success" to={`site-locations/details/${site._id}`}>
              View
            </Link>            
          </div>
        </Spin>
      </Popup>
    </Marker>
  );
};

export default MapMarker;

MapMarker.propTypes = {
  site: PropTypes.object.isRequired,
  markerLoading: PropTypes.bool,
  handleMarkerClick: PropTypes.func,
  markerData: PropTypes.object,
};

const getMarkerColor = (alarmStatus) => {
  if (alarmStatus === "critical") return "red";
  else if (alarmStatus === "caution") return "yellow";
  else if (alarmStatus === "high") return "orange";
  else return "green";
};
